import { DateTime } from 'luxon';
import { NodeSortOrder } from '../global-entities/global-entities';
import { NodeListSearch } from '../request-models/request-models';

export class BulkImportStartRequest {
  // username: string;
  propertyId: number;
  // propertyCode: string;
  language: string[] = [];
  timezoneId: string;
  static toQueryParams(req: BulkImportStartRequest) {
    return {
      propertyId: req.propertyId,
      language: req.language,
      timezoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
  }
}

export class ReportsDataRequest {
  propertyId: number[];
  languageCode: string[];
}

export class BulkImportSearch extends NodeListSearch {
  importId?: string[];
  startDate?: DateTime;
  orders?: NodeSortOrder[];
  limit = 25;
}

export enum ExcelImportEntity {
  Asset = 1,
  PM,
  Checklist,
  Contractor,
  WODescription,
}

export class BulkImportSearchForm {
  propertyId: number;
  ExcelImportEntity: ExcelImportEntity;
}

export enum ImportStatuses {
  Started = 'STARTED',
  Error = 'ERROR',
  InProgress = 'INPROGRESS',
  Importing = 'IMPORTING',
  NotImported = 'NOT_IMPORTED',
  Finished = 'FINISHED',
}

export class BulkImportAttempt {
  importDataId: number;
  userId: string;
  userFullName?: string;
  fileName: string;
  fileUuid: string;

  insertedRecords: number;
  processed: number;
  totalRecord: number;

  createdAt?: DateTime;
  updatedAt?: DateTime;
  processedOn?: DateTime;
  fileLocation?: string;
}

export enum BulkImportViewStates {
  Pending = 0,
  Uploading = 0.5,
  Uploaded = 1,
  Started = 2,
  Finished = 4,
}

export class BulkImportAttemptStatus {
  /** total number of errors found (there can be multiple errors for single excel row) */
  errorRows: number;
  overAllStatus: BulkImportViewStates;
  /** number of rows inserted in db, over all tables */
  processedRows: number;
  totalRows: number;
  /** number of rows updated in db, over all tables */
  updatedRows?: number;
  progressPercentage?: number;
}

export class BulkImportAttemptLog {
  fileUuid: string;
  importDataLogId: number;
  rowIndex: number;
  rowData;
  status: ImportStatuses;
  statusText: string;
  createdAt?: DateTime;
  updatedAt?: DateTime;
}
